<template>
    <div class="addnotice" >
        <!-- 导航栏 -->
		<van-nav-bar
		class="bar"
		        title="新增通知"
		        left-arrow
		        @click-left="onClickLeft"
		/>
		<!-- <van-nav-bar title="新增通知" left-arrow @click-left="onClickLeft" /> -->
       
		<div class="noticeForm">
			 <h4 class="noticeTitle">法律援助申请通知</h4>
		  <van-field v-model="title" :border="false"  label="标题："  class="formwork"/>
		  <van-field v-model="organization"  label="办理单位："  :border="false" class="formwork" />
			<van-field
			  v-model="remark"
			  rows="3"
			  autosize
			 type="textarea"
			  maxlength="50"
			  placeholder="请输入留言"
			label=" 备注："
			 :border="false" 
				class="formwork"/>
		</div>
        <van-form validate-first @failed="onFailed" @submit="submit">
          
		<van-field
				v-model="title"
				name="validator"
				label="标题"
				placeholder="请输入标题"
				autosize
				:rules="[{ validator, message: `请输入标题`}]"
		/>
			<van-field
                    v-model="userName"
                    name="validator"
                    label="受援人"
                    placeholder="请输入姓名"
					autosize
                    :rules="[{ validator, message: `请输入姓名`}]"
            />
            <van-field
			label-width="120px"
                    v-model="lawyerOrname"
                    name="validator"
                    label="指派单位或律师"
                    placeholder="机构名称或姓名"
					:rules="[{ validator, message: `请输入机构名称或姓名`}]"
            />
			<van-field
			
				label="联系电话"
				placeholder="请输入手机号"
				@blur="checkPhone" :error-message="errMsg.mobilePhone" 
				  v-model.trim="form.mobilePhone"
				  clearable
			/>
			<van-field
				v-model="organization"
				name="validator"
				label="办理单位"
				placeholder="请输入办理单位"
				autosize
				:rules="[{ validator, message: `请输入办理单位`}]"
			/>
			<div class="checkbox">
				 <van-checkbox v-model="checkbox" shape="square" style="margin-right: 10px;" />勾选群发消息
			</div>
			<div style="margin: 16px;">
			    <van-button round block type="info" native-type="submit" >
			        提交
			    </van-button>
			</div>
			 
        </van-form>
    </div>
</template>
<!-- native-type="submit" -->
<script>
  import axios from '../common/axios'
  import {responseCodes} from '../common/const'
  import {Toast} from 'vant'
 


  export default {
    data() {
      return {
		title:'关于我中心法律援助通知公告',
        userName: '',
        lawyerOrname: '',
        phone: '',
		organization:'金台区法律援助中心',
		form: {
			mobilePhone: ''
		  },
		 errMsg: {
			mobilePhone: ''
		  },
		value:'',
		remark:'',
		checkbox: false,
		checkboxGroup: [],
      };
    },
	mounted(){
		
		this.remark="您申请的法律援助事项，审批通过，决定给予法律援助，现在指派"+this.lawyerOrname+"办理,联系电话："
	},
	  updated(){
	        // 正确的初始化方式
	        this.remark ="【"+ this.userName+"】"+"您申请的法律援助事项，审批通过，决定给予法律援助，现在指派"+"【"+ this.lawyerOrname+"】"+"办理,联系电话："+"【"+ this.form.mobilePhone+"】"
	      },
    methods: {
      validator(val) {
		 return val.trim().length>0
       
      },
	   checkPhone() {
		   var reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
	        if (!this.form.mobilePhone) {
	          this.errMsg.mobilePhone = '请填写手机号码！'
	          return 
	        } else if (!reg.test(this.form.mobilePhone)) {
	          this.errMsg.mobilePhone = '手机号格式不正确！'
	          return 
	        } else {
	          this.errMsg.mobilePhone = ''
	          return 
	        }
	      },
      onFailed(errorInfo) {
        console.log('failed', errorInfo);
      },

      onClickLeft() {
        this.$router.back();
      },
      async submit(){
		 if( this.errMsg.mobilePhone!==''){
			return; 
		 }
		 
        this.$store.commit("showOverlay");
        let notice = {
			  userName: this.userName,
			  attorney:this.lawyerOrname,
			  attorneyPhone:this.form.mobilePhone, 
			  operatorId:this.$store.state.user.openId,
			  ifMass:this.checkbox,
			  message:this.remark,
			  title:this.title,
			  stateStr:'审批通过',
			  groupName:this.organization,
		  
        };
		 try {
          let response = await axios.post("/fyserve/aid/add" ,notice)
          let data = response.data;
          if (data.code === responseCodes.success) {
             this.$emit('addconsult')
          }else{
            Toast.fail(data.message);
          }
        }catch (e) {
          console.error(e)
          Toast.fail("加载数据失败")
        }finally {
          this.$store.commit("hideOverlay")
          this.userName = '';
          this.lawyerOrname = '';
          this.form.mobilePhone = '';
	}
      }
    },
  };
</script>

<style>
	
	.addnotice{
		margin-bottom: 60px;
	
	}
	.bar{
		width: 100%;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 40;
	}
	.noticeForm{
		margin-top:52px;
		margin-bottom: 10px;
	}
	.noticeTitle{
		text-indent: 16px;
		margin-bottom: 10px;
	}
.formwork{
	padding-top: 0;
	padding-bottom: 0;
}
.checkbox{
	margin-top:20px;
	justify-content: center;
	display: flex;
}
.button{
	width: 50%;
	border-radius: 5px;
}
</style>
